// frontend/src/static/js/api/chat.js

const API_URL = "/api"; // production will use NGINX to forward this to backend

export const sendMessage = async (message, sessionId) => {
  const response = await fetch(`${API_URL}/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message, session_id: sessionId }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error ${response.status}: ${errorText}`);
  }

  return response.json();
};

export const getSummary = async (sessionId) => {
  const response = await fetch(`${API_URL}/summary/${sessionId}`);

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error ${response.status}: ${errorText}`);
  }

  return response.json();
};

